var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg",staticStyle:{"height":"99%","overflow":"hidden"}},[(_vm.isHas)?_c('trace-data'):_c('trace-search')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }